/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Section_2_HeadingInputs */

const en_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The follow through as protection`)
};

const es_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El follow through como protección`)
};

const de_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Durchschwung als Schutz`)
};

const zh_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送杆就是保护`)
};

const ar_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتابعة كحماية`)
};

const fr_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’accompagnement comme protection`)
};

const vi_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow through như lá chắn`)
};

const sw_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-through kama kinga`)
};

const th_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟอลโลว์ทรูในฐานะเกราะป้องกัน`)
};

const bs_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow through kao zaštita`)
};

const ja_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体を守るフォロースルー`)
};

const ko_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몸을 보호하는 팔로스루`)
};

const pt_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O follow-through como proteção`)
};

const it_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’accompagnamento come protezione`)
};

const sv_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genomsvingen som skydd`)
};

const nl_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De doorzwaai als bescherming`)
};

const da_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemsvinget som beskyttelse`)
};

const nb_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gjennomsvingen som beskyttelse`)
};

const fi_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läpivienti suojana`)
};

const pl_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejście przez piłkę jako ochrona`)
};

const ru_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проводка как защита`)
};

const tr_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koruma olarak takip`)
};

const hi_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुरक्षा के रूप में फ़ॉलो-थ्रू`)
};

const id_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-through sebagai pelindung`)
};

const ms_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikut-lajak sebagai perlindungan`)
};

const cs_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Došvih jako ochrana`)
};

const el_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η συνέχεια της κίνησης ως προστασία`)
};

const he_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפולו-ת'רו כהגנה`)
};

const af_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die deurvolg as beskerming`)
};

const hu_injury_content_section_2_heading = /** @type {(inputs: Injury_Content_Section_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kilendítés mint védelem`)
};

/**
* | output |
* | --- |
* | "The follow through as protection" |
*
* @param {Injury_Content_Section_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_section_2_heading = /** @type {((inputs?: Injury_Content_Section_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Section_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_section_2_heading(inputs)
	if (locale === "de") return de_injury_content_section_2_heading(inputs)
	if (locale === "zh") return zh_injury_content_section_2_heading(inputs)
	if (locale === "ar") return ar_injury_content_section_2_heading(inputs)
	if (locale === "fr") return fr_injury_content_section_2_heading(inputs)
	if (locale === "vi") return vi_injury_content_section_2_heading(inputs)
	if (locale === "sw") return sw_injury_content_section_2_heading(inputs)
	if (locale === "th") return th_injury_content_section_2_heading(inputs)
	if (locale === "bs") return bs_injury_content_section_2_heading(inputs)
	if (locale === "ja") return ja_injury_content_section_2_heading(inputs)
	if (locale === "ko") return ko_injury_content_section_2_heading(inputs)
	if (locale === "pt") return pt_injury_content_section_2_heading(inputs)
	if (locale === "it") return it_injury_content_section_2_heading(inputs)
	if (locale === "sv") return sv_injury_content_section_2_heading(inputs)
	if (locale === "nl") return nl_injury_content_section_2_heading(inputs)
	if (locale === "da") return da_injury_content_section_2_heading(inputs)
	if (locale === "nb") return nb_injury_content_section_2_heading(inputs)
	if (locale === "fi") return fi_injury_content_section_2_heading(inputs)
	if (locale === "pl") return pl_injury_content_section_2_heading(inputs)
	if (locale === "ru") return ru_injury_content_section_2_heading(inputs)
	if (locale === "tr") return tr_injury_content_section_2_heading(inputs)
	if (locale === "hi") return hi_injury_content_section_2_heading(inputs)
	if (locale === "id") return id_injury_content_section_2_heading(inputs)
	if (locale === "ms") return ms_injury_content_section_2_heading(inputs)
	if (locale === "cs") return cs_injury_content_section_2_heading(inputs)
	if (locale === "el") return el_injury_content_section_2_heading(inputs)
	if (locale === "he") return he_injury_content_section_2_heading(inputs)
	if (locale === "af") return af_injury_content_section_2_heading(inputs)
	if (locale === "hu") return hu_injury_content_section_2_heading(inputs)
	return en_injury_content_section_2_heading(inputs)
});